import { NgModule } from '@angular/core';
// import { FormsModule } from "@angular/forms";
import { MatSelectModule } from '@angular/material/select';
import { ProductsContainerDirective } from 'src/app/global/directives/products-container/products-container.directive';
import { ChangedotPipe } from 'src/app/global/pipes/changedot.pipe';
import { DelcomaPipe } from 'src/app/global/pipes/delcoma.pipe';
import { ThousandsPipe } from 'src/app/global/pipes/thousands.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { CarroCompraComponent } from 'src/app/shared/ui/carro-compra/carro-compra.component';
import { BaseProductComponent } from './base-product/base-product.component';
import { IntegrationProductComponent } from './integration-product/integration-product.component';
import { LinkPagoProductComponent } from './link-pago-product/link-pago-product.component';
import { PosPackProductComponent } from './pos-pack-product/pos-pack-product.component';
import { PosProductComponent } from './pos-product/pos-product.component';
import { ProductsWrapperComponent } from './products-wrapper/products-wrapper.component';
import { QrProductComponent } from './qr-product/qr-product.component';
import { WebSiteProductComponent } from './web-site-product/web-site-product.component';
import { WixProductComponent } from './wix-product/wix-product.component';

@NgModule({
    declarations: [
        ProductsContainerDirective,

        CarroCompraComponent,
        ProductsWrapperComponent,
        BaseProductComponent,
        QrProductComponent,
        PosProductComponent,
        PosPackProductComponent,
        IntegrationProductComponent,
        WebSiteProductComponent,
        WixProductComponent,
        LinkPagoProductComponent,
        DelcomaPipe,
        ThousandsPipe,
        ChangedotPipe


    ],
    imports: [
        // CommonModule,
        // FormsModule,
        SharedModule,
        MatSelectModule
    ],
    exports: [
        CarroCompraComponent,
        ProductsWrapperComponent,
        ProductsContainerDirective, ThousandsPipe
    ]
})
export class ShoppingCartModule { }
